var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarMarkStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Calendar-Mark--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Calendar Mark Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-mark--calendar-date-day-month-mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fill: "#ffffff",
    d: "M2.4482449242857145 27.99188742857143c0.44023899000000005 3.781117285714286 3.632687275714286 6.7830904285714295 7.580377461428571 6.966137571428572 2.7285962142857145 0.12654128571428572 5.515953214285715 0.19233214285714287 8.54111232857143 0.19233214285714287 3.025185642857143 0 5.812516114285715 -0.06579085714285715 8.541138857142856 -0.19233214285714287 3.9477167142857144 -0.18304714285714288 7.1401650000000005 -3.1850202857142857 7.580274000000001 -6.966137571428572 0.6114835714285715 -5.251410300000001 0.6114835714285715 -9.723517285714285 0 -14.975033700000001 -0.44010900000000003 -3.7810111714285717 -3.632557285714286 -6.783063900000001 -7.580274000000001 -6.966084514285715 -2.728622742857143 -0.12651475714285715 -5.515953214285715 -0.19227908571428573 -8.541138857142856 -0.19227908571428573 -3.025159114285714 0 -5.812516114285715 0.06576432857142857 -8.54111232857143 0.19227908571428573 -3.947690185714286 0.18302061428571428 -7.140138471428572 3.185073342857143 -7.580377461428571 6.966084514285715 -0.6114703071428572 5.251516414285715 -0.6114676542857144 9.723623400000001 0 14.975033700000001Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.4482449242857145 27.99188742857143c0.44023899000000005 3.781117285714286 3.632687275714286 6.7830904285714295 7.580377461428571 6.966137571428572 2.7285962142857145 0.12654128571428572 5.515953214285715 0.19233214285714287 8.54111232857143 0.19233214285714287 3.025185642857143 0 5.812516114285715 -0.06579085714285715 8.541138857142856 -0.19233214285714287 3.9477167142857144 -0.18304714285714288 7.1401650000000005 -3.1850202857142857 7.580274000000001 -6.966137571428572 0.6114835714285715 -5.251410300000001 0.6114835714285715 -9.723517285714285 0 -14.975033700000001 -0.44010900000000003 -3.7810111714285717 -3.632557285714286 -6.783063900000001 -7.580274000000001 -6.966084514285715 -2.7285962142857145 -0.12651475714285715 -5.515953214285715 -0.19227908571428573 -8.541138857142856 -0.19227908571428573 -3.025159114285714 0 -5.812516114285715 0.06576432857142857 -8.54111232857143 0.19227908571428573 -3.947690185714286 0.18302061428571428 -7.140138471428572 3.185073342857143 -7.580377461428571 6.966084514285715 -0.6114703071428572 5.251516414285715 -0.6114676542857144 9.723623400000001 0 14.975033700000001Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 3",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11.279815928571429 1.9896428571428573 0 7.295357142857143",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 4",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m25.86018407142857 1.9896428571428573 0 7.295357142857143",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.28241572857143 18.660037971428572c-0.42445714285714287 0 -0.6632142857142858 -0.23875714285714286 -0.6632142857142858 -0.6632142857142858s0.23875714285714286 -0.6632142857142858 0.6632142857142858 -0.6632142857142858",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.2875888 18.660037971428572c0.42445714285714287 0 0.6632142857142858 -0.23875714285714286 0.6632142857142858 -0.6632142857142858s-0.23875714285714286 -0.6632142857142858 -0.6632142857142858 -0.6632142857142858",
    strokeWidth: 2.86
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.28241572857143 26.618503285714286c-0.42445714285714287 0 -0.6632142857142858 -0.2386510285714286 -0.6632142857142858 -0.6631081714285715 0 -0.42445714285714287 0.23875714285714286 -0.6632142857142858 0.6632142857142858 -0.6632142857142858",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.2875888 26.618503285714286c0.42445714285714287 0 0.6632142857142858 -0.2386510285714286 0.6632142857142858 -0.6631081714285715 0 -0.42445714285714287 -0.23875714285714286 -0.6632142857142858 -0.6632142857142858 -0.6632142857142858",
    strokeWidth: 2.86
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.56482692857143 18.660037971428572c-0.42445714285714287 0 -0.6632142857142858 -0.23875714285714286 -0.6632142857142858 -0.6632142857142858s0.23875714285714286 -0.6632142857142858 0.6632142857142858 -0.6632142857142858",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.57 18.660037971428572c0.42445714285714287 0 0.6632142857142858 -0.23875714285714286 0.6632142857142858 -0.6632142857142858s-0.23875714285714286 -0.6632142857142858 -0.6632142857142858 -0.6632142857142858",
    strokeWidth: 2.86
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.56482692857143 26.618503285714286c-0.42445714285714287 0 -0.6632142857142858 -0.2386510285714286 -0.6632142857142858 -0.6631081714285715 0 -0.42445714285714287 0.23875714285714286 -0.6632142857142858 0.6632142857142858 -0.6632142857142858",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.57 26.618503285714286c0.42445714285714287 0 0.6632142857142858 -0.2386510285714286 0.6632142857142858 -0.6631081714285715 0 -0.42445714285714287 -0.23875714285714286 -0.6632142857142858 -0.6632142857142858 -0.6632142857142858",
    strokeWidth: 2.86
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M25.852411200000002 18.660037971428572c-0.42445714285714287 0 -0.6632142857142858 -0.23875714285714286 -0.6632142857142858 -0.6632142857142858s0.23875714285714286 -0.6632142857142858 0.6632142857142858 -0.6632142857142858",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M25.857584271428575 18.660037971428572c0.42445714285714287 0 0.6632142857142858 -0.23875714285714286 0.6632142857142858 -0.6632142857142858s-0.23875714285714286 -0.6632142857142858 -0.6632142857142858 -0.6632142857142858",
    strokeWidth: 2.86
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMarkStreamlineFlex);
export default __webpack_public_path__ + "static/media/Calendar-Mark--Streamline-Flex.0c44dd4c31772f0408ba625ff6f681e2.svg";
export { ForwardRef as ReactComponent };